/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

import type { Editor, ModelElement, ViewPosition } from 'ckeditor5';

const MAXIMUM_TRANSCODING_IMAGES = 26;

/**
 * Helper function to return the correct image asset. We always return the scaled image asset if one exists, otherwise
 * we return the full image asset.
 *
 * @param assetObject An object that represents the needed IDs for the asset we're transcoding.
 *
 * @returns {null} Returns null.
 */
export function checkTranscodingProgress(assetObject: { assetType: string; contentBlockId: any; unitId: any; assetId: any; }) {
  const { Restangular } = window as any;
  const blockName = (assetObject.assetType === 'AUDIO') ? 'audioblock' : 'videoblock';
  const block = document.querySelector(`[bulb-block-id='${assetObject.contentBlockId}']`);
  if (!block) {
    return 'clearInterval';
  }
  return Restangular.one('units', assetObject.unitId)
    .one(blockName, assetObject.assetId)
    .customGET('status');
}

/**
 * Method that fetches the updated contentBlock after transcoding.
 *
 * @param editor Editor instance.
 * @param assetObject asset object with all necessary information.
 * @param modelElement Model element.
 * @param insertionPosition model insert positino.
 */
export function getUpdatedContentBlock(
  editor: Editor,
  assetObject,
  modelElement: ModelElement,
  insertionPosition: ViewPosition,
): void {
  const { Restangular } = window as any;
  const commandName = (assetObject.assetType === 'AUDIO') ? 'insertAudio' : 'insertVideo';
  Restangular.one('units', assetObject.unitId)
    .one('contentblock', assetObject.contentBlockId).get().then((contentBlock) => {
      CKEBulbData.page.unit.contentBlocks[contentBlock.id] = contentBlock;
      editor.execute(commandName, contentBlock, modelElement, insertionPosition);
    });
}

/**
 * Method to generate a 'randomized' image for used in the background or the custom bulb upload placeholder block.
 *
 * @returns {string}
 */
export function generateTranscodingBackground(): string {
  return `https://assets.bulbapp.com/transcoding/${Math.floor(Math.random() * MAXIMUM_TRANSCODING_IMAGES) + 1}.jpg`;
}
